/**
 * EmailSentIllustration Component - Minimalist Design
 * Clean visual illustration for email sent confirmation
 */

import React from 'react';

export const EmailSentIllustration: React.FC = () => {
  return (
    <div className="relative z-10 max-w-md text-center">
      {/* Minimalist Email Icon */}
      <div className="flex items-center justify-center mb-6">
        <div className="bg-white rounded-full p-6 shadow-lg">
          <svg 
            className="h-12 w-12 text-blue-600" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
            />
          </svg>
        </div>
      </div>
      
      {/* Clean Heading */}
      <h2 className="text-white text-2xl font-semibold mb-3 leading-tight">
        Cek Email Anda
      </h2>
      
      {/* Concise Description */}
      <p className="text-primary-100 text-base leading-relaxed">
        Link konfirmasi telah dikirim ke email Anda. Cek inbox dan folder spam untuk mengaktifkan akun.
      </p>
    </div>
  );
};